import { render } from "./ImprovementScope.vue?vue&type=template&id=65e4ac1e&scoped=true"
import script from "./ImprovementScope.vue?vue&type=script&lang=js"
export * from "./ImprovementScope.vue?vue&type=script&lang=js"

import "./ImprovementScope.vue?vue&type=style&index=0&id=65e4ac1e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e4ac1e"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
